import { mapState } from 'vuex'
import { h } from 'vue'

import __C from '../../../../src/primitives/_constant_'
import '../../../../src/assets/stylus/ui/component/_jDatagridTitle.scss'
import SummaryCharts from '../../../../src/components/DatatableSummaryCharts'

import { VIcon, VCol } from 'vuetify/components'
import JPagination from '../JPagination'

export default {
  name: 'j-data-grid-title',
  components: {
    JPagination,
    VIcon,
    VCol,
  },
  props: {
    sideslide: Boolean,
    attrs: { type: Object, default: () => ({}) },
    inputFilter: String,
    // legend <= tableAttrs.style
    legendItems: { type: Object, default: () => null },
    pagination: { type: Object, default: () => null },
    chartComponentName: null,
    chartData: null,
  },
  data: () => ({
    currentPage: 1,
    inputValue: '',
  }),
  computed: {
    ...mapState(__C.STORE_NAMESPACE.ACCOUNT, ['account']),

    titleWrapStyle() {
      if (!this.attrs.main) return {}
      return {
        style: {
          display: 'flex',
          'align-items': 'flex-end',
        },
      }
    },
    titleMain() {
      return this.attrs.main ? this.attrs.main.text : ''
    },
    titleMainStyle() {
      if (!this.attrs.main) return {}
      return {
        style: {
          'font-family': this.attrs.main.font,
          'font-size': `${this.attrs.main.fontSize}px`,
          color: this.sideslide ? '#2196f3' : this.attrs.main.color,
          'margin-right': '7px',
        },
      }
    },
    titleSub() {
      return this.attrs.sub ? this.attrs.sub.text : ''
    },
    titleSubStyle() {
      if (!this.attrs.sub) return {}
      return {
        style: {
          'font-family': this.attrs.sub.font,
          'font-size': `${this.attrs.sub.fontSize}px`,
          color: this.attrs.sub.color,
          'margin-bottom': '2px',
        },
      }
    },
    titleData1() {
      return this.attrs.queries ? this.attrs.queries._1st : ''
    },
    titleData2() {
      return this.attrs.queries ? this.attrs.queries._2nd : ''
    },
    titleData3() {
      return this.attrs.queries ? this.attrs.queries._3rd : ''
    },
    titleData4() {
      return this.attrs.queries ? this.attrs.queries._4th : ''
    },
    titleData5() {
      return this.attrs.queries ? this.attrs.queries._5th : ''
    },
    titleDataStyle() {
      if (!this.attrs.query) return {}
      return {
        style: {
          'font-family': this.attrs.query.font,
          'font-size': `${this.attrs.query.fontSize}px`,
          color: this.attrs.query.color,
          'padding-bottom': '7px',
        },
      }
    },
    noteStyle() {
      if (!this.attrs.sub) return {}
      return {
        style: {
          'font-family': this.attrs.note.font,
          'font-size': `${this.attrs.note.fontSize}px`,
          color: this.attrs.note.color,
          'padding-bottom': '7px',
        },
      }
    },
  },
  methods: {
    
    getTitleData() {
      let titleData__ = ''
      if (this.titleData1) titleData__ += this.titleData1
      if (this.titleData2) titleData__ += this.titleData2
      if (this.titleData3) titleData__ += this.titleData3
      if (this.titleData4) titleData__ += this.titleData4
      if (this.titleData5) titleData__ += this.titleData5

      if (!titleData__) return null
      return h('div', [
        h('pre', this.titleDataStyle, [titleData__]),
      ])
    },
    
    getNote() {
      if (!this.attrs.note || !this.attrs.note.text) return null
      return h('div', [
        h('pre', this.noteStyle, [this.attrs.note.text]),
      ])
    },

    getLegend() {
      if (this.attrs.showLegend != 'Y') return null
      if (!this.legendItems || Object.keys(this.legendItems).length === 0) return null

      let propNames_ = ['cell', 'color', 'text']
      let draw = (name, items) =>
        items.map((item_) => {
          let data = {
            style: {
              color: item_.tColor,
              'padding-left': '1rem',
              'padding-right': '1rem',
              'margin-right': '1rem',
            },
          }
          if (name == 'cell')
            data.style['background'] = `linear-gradient(to right, ${item_.bColor} 50%, #fff 50%)`
          else if (name == 'color') data.style['background-color'] = item_.bColor
          else {
            data.style['padding-left'] = '3px'
            data.style['padding-right'] = '3px'
          }

          return h('div', data, [item_.text || item_.code])
        })

      let legendItems_ = []
      propNames_.forEach((name) => {
        legendItems_ = [...legendItems_, ...draw(name, this.legendItems[name])]
      })

      let data = {
        style: {
          display: 'flex',
          'line-height': '1.4rem',
          'padding-bottom': '7px',
        },
      }
      return h('div', data, legendItems_)
    },

    genPagination() {
      if (
        !this.attrs.pagination ||
        this.attrs.pagination.type != 'page' ||
        this.attrs.pagination.enabled == 'N'
      ) return null
      
      return h(JPagination, {
        showStatus: this.attrs.pagination.showPageNo == 'Y',
        pagination: this.pagination,
        sideslide: this.sideslide,
        onFirst: () => this.$emit('first'),
        onPrevious: (v) => this.$emit('previous', v),
        onNext: (v) => this.$emit('next', v),
        onLast: (v) => this.$emit('last', v)

      })
    },
    
    genSearchInput() {
      if (this.attrs.showSearchInput != 'Y') return null

      const inputAttrs = {
        type: 'search',
        name: 'q',
        placeholder: 'Filter and search',
        autocomplete: 'off',
        value: this.inputValue || this.inputFilter,
        style: {
          color: '#fff',
          fontWeight: 'bold',
        },
        onKeyup: (e) => {
          this.inputValue = e.target.value
          if (e.key === 'Enter') this.$emit('input-filter', e.target.value)
        }
      }

      const btClearAttrs = {
        type: 'submit',
        style: { 'margin-right': '-5px' },
        onClick: () => {
          this.inputValue = ''
          this.$emit('input-filter', '')
        }
      }

      const btSearchAttrs = {
        type: 'submit',
        onClick: () => {
          this.$emit('input-filter', this.inputValue)
        }
      }

      let buttons = [
        h('button', btSearchAttrs, [h(VIcon, null, {default: () => 'mdi-magnify'})])
      ]
      
      if (this.inputValue) {
        buttons = [
          h('button', btClearAttrs, [
            h('i', {
              'aria-hidden': 'true',
              title: 'Clear Text',              
              class: 'v-icon v-icon--link mdi mdi-close v-theme--light',
            })
          ]),
          ...buttons
        ]
      }
      
      if (this.sideslide) {
        return h('div', {
          style: {
            border: '#ccc',
            'background-color': 'rgb(222, 222, 222)',
            opacity: '1',
          },
          class: 'j_search type01',
        }, [h('input', inputAttrs), ...buttons])
      } else {
        return h('div', { class: 'j_search type01' }, [
          h('input', inputAttrs),
          ...buttons
        ])
      }
    },
    genExcelExport() {
      if (this.attrs.showExcelExport != 'Y') return null

      return h('button', {
        class: 'j_button type01 sky',
        onClick: () => {
          this.$emit('excel-download')
        }
      }, [
        h('i', { class: 'jcon_download_02' }),
        h('span', 'EXCEL')
      ])
    },
    genActionButton() {
      // As of 2022 08 18, Action Button is fixed only for custom component 'Model Review Comment'
      // It should be updated to process "request-action" with ...

      const actionButton = this.attrs.actionButton
      if (
        this.account.permitLevel > __C.ACCOUNT.PERMISSION_LEVEL.DESIGNER ||
        !actionButton ||
        actionButton.activate != 'Y'
      )
        return null

      return h('button', {
        class: 'j_button type01 sky',
        onClick: () => {
          this.$emit('request-action', {
            action: {
              target: 'slide-modal',
              component: actionButton.component,
            },
          })
        }
      }, [
        h('span', actionButton.label)
      ])
    },
    genSummaryChart() {
      if (!this.chartData) return null
      
      const component = SummaryCharts[this.chartComponentName]
      return h(component, {
        items: this.chartData,        
        onRequestAction: (req) => {
          this.$emit('request-action', req)
        },
      })
    },
  },
  render() {
    return h('div', { class: 'j_datagrid_title' }, [
      h('div', [
        h('div', this.titleWrapStyle, [
          h('h5', this.titleMainStyle, this.titleMain),
          h('small', this.titleSubStyle, this.titleSub)
        ]),
        this.getTitleData(),
        this.getNote(),
        this.getLegend()
      ]),
      h('div', { class: '__title__center' }, [this.genSummaryChart()]),
      h('div', { class: '__title__right' }, [
        this.genPagination(),
        this.genSearchInput(),
        this.genExcelExport(),
        this.genActionButton()
      ])
    ])
  },
}
